import { uniq } from './filterUtils';

export const getMostUsedSourceLanguagesUtil = (languagePairs: string[]) =>
  languagePairs.map((codes) => codes.split('-')[0]).filter(uniq);
